import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './../locales/en/translation.json'
import hrTranslation from './../locales/hr/translatiion.json';

i18n
  .use(LanguageDetector) // Detect browser language
  .use(initReactI18next) // Connect with React
  .init({
    resources: {
      en: { translation: enTranslation },
      hr: { translation: hrTranslation },
    },
    fallbackLng: 'hr',
    lng: 'hr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
